import { call, select, takeEvery } from 'redux-saga/effects';
import {
  AddVertragToAngebote,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App, FEVorvertragsnummer, normalizeApp, Vorvertrag } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '@ps20-frontend/apps/dashboard-store';
import { StandaloneProduktEinschliessen } from '../model/standaloneProduktEinschliessen';
import { DashboardAction, DashboardActions } from '../dashboard.actions';

export function* watchStandaloneEinschliessen() {
  yield takeEvery(
    DashboardActions.STANDALONE_PRODUKT_EINSCHLIESSEN,
    safeSaga(produktEinschliessen, App.SHOP_DASHBOARD),
  );
}

export function* produktEinschliessen(action: DashboardAction<StandaloneProduktEinschliessen>) {
  const globalPut = GlobalPut.getInstance();
  const payload: StandaloneProduktEinschliessen = action.payload;
  const vorvertragsNummern: Array<FEVorvertragsnummer> = payload.produkte.map(
    (produkt): FEVorvertragsnummer => ({
      spLaufnummer: produkt.spLaufnummer,
      vertragsnummer: produkt.vertragsnummer,
    }),
  );
  if (payload.vorvertraege) {
    payload.vorvertraege.forEach(vorvertrag =>
      vorvertragsNummern.push({
        spLaufnummer: vorvertrag.spLaufnummer,
        vertragsnummer: vorvertrag.vertragsnummer,
      }),
    );
  }
  const vorvertragSofortschutz: boolean = payload.vorvertraege
    ? payload.vorvertraege.some(vorvertrag => vorvertrag.vorvertragSofortschutz)
    : false;
  const state = (yield select()) as IAppState;
  let produktId = payload.choosenApp;
  const sourceAppType = payload.choosenApp; // Original app type from loaded contract
  const beibehalten = false; // This is "umstellen" operation

  produktId = normalizeApp(produktId, {
    sourceAppType: sourceAppType,
    beibehalten: beibehalten,
    featureToggles: state.transientState?.featureToggles as { [key: string]: boolean },
  });
  const addVertragPayload: AddVertragToAngebote = {
    appId: produktId,
    vorvertragsNummern,
    vorvertragSofortschutz,
    beibehalten: false,
    noUmgestellteIdsHinweis: payload.noUmgestellteIdsHinweis,
  };

  const vorvertragMitProduktlinie = getProduktlinienName(payload);
  if (vorvertragMitProduktlinie) {
    addVertragPayload.linieOfVorvertrag = vorvertragMitProduktlinie.produktlinieAnzeigename;
  }
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().requestAddVertragToAngebote(addVertragPayload),
  );
}

function getProduktlinienName(payload: StandaloneProduktEinschliessen): Vorvertrag {
  return payload.vorvertraege?.find(
    vorvertrag =>
      vorvertrag.produktlinieAnzeigename && vorvertrag.produktlinieAnzeigename.length > 0,
  );
}
